import { cn } from "@/lib/utils";

interface PlanFeatureChipProps {
  label: string;
  /** Já formatado por `formatLimit` — o componente não decide texto de limite. */
  limit: string;
  enabled: boolean;
}

/**
 * Um opcional do plano: o nome à esquerda, o limite à direita.
 *
 * Reusa o chip claro do `FeatureItem` de hoje (`bg-tami-light rounded-xl`); o
 * que muda é que o número deixou de ser texto escrito à mão e passou a vir dos
 * limites configurados no plano.
 *
 * A `min-h` fixa não é decoração: sem ela, o chip de rótulo curto fica mais
 * baixo que o de rótulo que quebra em duas linhas, e o ritmo da coluna desanda.
 */
export const PlanFeatureChip = ({
  label,
  limit,
  enabled,
}: PlanFeatureChipProps) => {
  return (
    <div
      className={cn(
        "flex min-h-[38px] items-center justify-between gap-2.5 rounded-xl px-3 py-1.5 md:min-h-[46px] md:py-2",
        enabled
          ? "bg-tami-light"
          : "border border-dashed border-tami-light/25 bg-tami-light/5",
      )}
    >
      <span
        className={cn(
          "text-[13px] font-semibold leading-tight md:text-sm",
          enabled ? "text-tami-dark" : "text-tami-light/45",
        )}
      >
        {label}
      </span>
      <span
        className={cn(
          "whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11.5px] font-bold",
          enabled
            ? "bg-tami-dark text-tami-light"
            : "border border-tami-light/25 text-tami-light/40",
        )}
      >
        {limit}
      </span>
    </div>
  );
};
